<div class="title" [ngClass]="isGraphDataChange ? 'mb-2' : 'mb-4'"> 
    <button mat-button class="menu-dropdown" [matMenuTriggerFor]="menu">{{selectedValue}}</button>
    <mat-menu #menu="matMenu" yPosition="above" class="belowmenu-position dashboard-menu">
        <button mat-menu-item (click)="setDate('Last 7 days')">Last 7 days</button>
        <button mat-menu-item (click)="setDate('Last 15 days')">Last 15 days</button>
        <button mat-menu-item (click)="setDate('Last 30 days')">Last 30 days</button>
        <button mat-menu-item (click)="setDate('Last 3 months')">Last 3 months</button>
        <button mat-menu-item (click)="setDate('Last 6 months')">Last 6 months</button>
        <button mat-menu-item (click)="setDate('Last 12 months')">Last 12 months</button>
        <button mat-menu-item class="date-item">
            <mat-form-field appearance="fill">
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="today">
                    <input matStartDate formControlName="start" placeholder="Start date" #dateRangeStart>
                    <input matEndDate formControlName="end" placeholder="End date" #dateRangeEnd
                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
            </mat-form-field>
        </button>
    </mat-menu>
</div>